//
//
//
//
//
//
//
//
//
//

import { ActionText, Typography } from '@backmarket/design-system'

import translations from './ToggleText.translations'

export default {
  components: {
    ActionText,
    Typography,
  },
  data() {
    return {
      isVisible: false,
    }
  },
  computed: {
    label() {
      return this.isVisible ? translations.hide : translations.show
    },
  },
  methods: {
    toggleDisplay() {
      this.isVisible = !this.isVisible
    },
  },
}
